import { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Typography } from '@mui/material'
import { getNotificationsKazoo } from '../../features/notificationSlice'
import ButtonCustom from '../../components/atoms/button/ButtonCustom'

import styles from './NotificationPage.module.scss'
import { NotificationTab } from '../../components/notification/NotificationTab'

export const KazooNotificationPage = () => {
	const dispatch = useDispatch()
	const { kazooId } = useParams()

	const notifications = useSelector(
		(state) => state.notification.kazooNotifications
	)

	const [markingAll, setMarkingAll] = useState(false)

	const today = new Date()
	const formattedDate = today.toLocaleDateString('en-US', {
		day: '2-digit',
		month: 'short',
		year: 'numeric',
	})

	useEffect(() => {
		dispatch(getNotificationsKazoo(kazooId))
	}, [dispatch, kazooId])

	const unread = useMemo(
		() => (notifications || []).filter((n) => n.status === 'unread'),
		[notifications]
	)

	// const handleMarkAllRead = async () => {
	// 	if (!unread.length || markingAll) return
	// 	setMarkingAll(true)
	// 	try {
	// 		await Promise.all(
	// 			unread.map((n) => dispatch(readNotification(n._id)))
	// 		)
	// 		dispatch(countUnreadNotifications())
	// 	} finally {
	// 		setMarkingAll(false)
	// 	}
	// }

	return (
		<div className={styles.pageWrap}>
			<div className={styles.pageHeader}>
				<Typography component="h1">Wedding Notifications</Typography>
				<div className={styles.right}>
					<div className={styles.date}>
						<img
							src="/images/calendar_line.svg"
							alt="calendar_line.svg"
						/>
						<span>{formattedDate}</span>
					</div>
					<ButtonCustom
						variant="outlined"
						size="lg"
						className={styles.markAll}
						// onClick={handleMarkAllRead}
						disabled={!unread.length || markingAll}
					>
						{markingAll ? 'Marking…' : 'Mark all as read'}
					</ButtonCustom>
				</div>
			</div>
			<NotificationTab
                notifications={notifications}
            />
		</div>
	)
}
